export default __webpack_public_path__ + "static/media/password.95f1863d.svg";